import React from "react";
import styles from "./ShareLocation.module.scss";
import commonStyles from "../components/components.module.scss";
import { Button } from "antd";
import { NodesUtil } from "../../NodesUtil";
export function ShareLocation() {
  var handleClick = function handleClick() {
    NodesUtil.getLocation();
  };
  return /*#__PURE__*/React.createElement("div", {
    className: commonStyles.viewBuilderComponents
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.shareLocation
  }, /*#__PURE__*/React.createElement("p", null, "Please share your location to proceed with the request"), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Button, {
    onClick: handleClick,
    type: "primary"
  }, "Share location"))));
}